__turbopack_context__.v({
  "brandTitle": "BrandTitle-module-scss-module__UGYOWa__brandTitle",
  "orange": "BrandTitle-module-scss-module__UGYOWa__orange",
  "white": "BrandTitle-module-scss-module__UGYOWa__white",
});
